export default __webpack_public_path__ + "static/media/Guru-brahma.4c7cc0e0.ogg";